import * as React from 'react';
import {Glyphicon} from 'react-bootstrap';

interface IssueBubbleProps { numIssues: number; severity: string }
export default class IssueSummaryBubble extends React.Component<IssueBubbleProps, {}> {
    render() {
        const {numIssues, severity} = this.props;
        var severityClass = "issuebubble " + severity;

        if (this.props.severity == "ok"){
            if (numIssues === 0) {
                return (<span className="issuebubble ok"><Glyphicon glyph="ok" /></span>);
            }  else {
                return null;
            }
        }

        if (numIssues === 0) return (null);
        return <span className={severityClass}>{numIssues}</span>;
    }
}
